import { useTranslation } from 'react-i18next';

export const OnlineViewersTitle = () => {
    const { t } = useTranslation();

    return <div className="font-accent font-w-heading text-lg">{t('Broadcaster.Dialog.TooEarly.OnlineViewersTitle')}</div>;
};
